import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfTimeInAppGoalService } from '../../../core/application/services/goals/get-self-time-in-app-goal.service';
import { SelfTimeInAppGoalEntity } from '../../../core/domain/entities/goals/app-goals/self-time-in-app-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfTimeInAppGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfTimeInAppGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfTimeInAppGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
